/* eslint-disable no-use-before-define */

/* eslint-disable no-unused-vars */

/* eslint-disable @typescript-eslint/no-unused-vars */
import React from "react";
import { Platform, Animated, StyleProp, ViewStyle, StyleSheet, View, TextStyle } from "react-native";
import SVG_Svg, {
  G as SVG_G,
  Path as SVG_Path,
  Text as SVG_Text,
  TSpan as SVG_TSpan,
  GProps,
  PathProps,
} from "react-native-svg";
/* SVGR has dropped some elements not supported by react-native-svg: desc */

const TSpan = Animated.createAnimatedComponent(SVG_TSpan);
const Text = Animated.createAnimatedComponent(SVG_Text);
const Path = Animated.createAnimatedComponent<
  React.ComponentClass<
    PathProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_Path);
const G = Animated.createAnimatedComponent<
  React.ComponentClass<
    GProps & {
      style?: StyleProp<ViewStyle>;
    }
  >
>(SVG_G);
const Svg = Animated.createAnimatedComponent(SVG_Svg);
import FontList from "react-native-font-list";
/***/

/*
 * -------------------------------------------------------------------------
 *
 *  /$$$$$$                                /$$$$$$$  /$$
 * |_  $$_/                               | $$__  $$| $$
 *   | $$   /$$$$$$/$$$$   /$$$$$$        | $$  \ $$| $$ /$$   /$$  /$$$$$$
 *   | $$  | $$_  $$_  $$ /$$__  $$       | $$$$$$$ | $$| $$  | $$ /$$__  $$
 *   | $$  | $$ \ $$ \ $$| $$  \ $$       | $$__  $$| $$| $$  | $$| $$$$$$$$
 *   | $$  | $$ | $$ | $$| $$  | $$       | $$  \ $$| $$| $$  | $$| $$_____/
 *  /$$$$$$| $$ | $$ | $$| $$$$$$$/  /$$  | $$$$$$$/| $$|  $$$$$$/|  $$$$$$$
 * |______/|__/ |__/ |__/| $$____/  |__/  |_______/ |__/ \______/  \_______/
 *                       | $$
 *                       | $$
 *                       |__/
 *
 * -------------------------------------------------------------------------
 *
 * ORIGINAL SVG
 * ---------------------------------
 * <svg xmlns="http://www.w3.org/2000/svg" width="158" height="40" viewBox="0 0 158 40" fill="none"> <desc id="IMP.BLUE">{"#Button_20_20Main":{"type":"SELECTOR","constraint":"none","width":158,"height":40},"#Rectangle_2051":{"type":"SELECTOR","constraint":"none","width":158,"height":40},"#JOIN_20THE_20MAIN_20TAB":{"type":"SELECTOR","constraint":"xMaxYMid meet","width":157.31304931640625,"height":40},"#Vector":{"type":"SELECTOR","constraint":"none","width":16,"height":16},"transforms":{"DownloadIcon":[{"name":"DownloadIcon","relativeTransforms":[[1,0,28],[0,1,11]],"rotation":0,"instanceParentName":"DownloadIcon","isInstanceParent":true,"isInstanceChild":false,"width":16,"height":16}],"Vector":[{"name":"Vector","relativeTransforms":[[1,0,0],[0,1,0]],"rotation":0,"instanceParentName":"DownloadIcon","isInstanceParent":false,"isInstanceChild":true,"width":16,"height":16}]},"tProps":{"type":"PROPS","NewProductButton?":"tButtonProps","onAnimationComplete?":"() => void","ImportButton?":"tButtonProps"},"#NewProductButton":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.NewProductButton?.onPress","animation":"touchableOpacity"},"constraint":"none","width":158,"height":40},"#DownloadIcon":{"type":"SELECTOR","constraint":"xMinYMid meet","width":16,"height":16},"#Import":{"type":"SELECTOR","constraint":"xMaxYMid meet","width":60,"height":26},"#Product":{"type":"SELECTOR","constraint":"xMaxYMid meet","width":73,"height":25},"#ImportButton":{"type":"SELECTOR","touchableOpacity":{"onPress":"props?.ImportButton?.onPress","animation":"touchableOpacity"},"constraint":"none","width":158,"height":40}}</desc>
 * <g id="ImportButton">
 * <rect id="Rectangle 51" width="158" height="40" rx="2" fill="#2C4B46"/>
 * <text id="Import" fill="white" xml:space="preserve" style="white-space: pre" font-family="Raleway" font-size="14" font-weight="600" letter-spacing="0.06em"><tspan x="88" y="0.441998">    </tspan><tspan x="59.3834" y="25.442">IMPORT</tspan></text>
 * <g id="DownloadIcon">
 * <path id="Vector" d="M42 22V25H30V22H28V25C28 26.1 28.9 27 30 27H42C43.1 27 44 26.1 44 25V22H42ZM41 18L39.59 16.59L37 19.17V11H35V19.17L32.41 16.59L31 18L36 23L41 18Z" fill="white"/>
 * </g>
 * </g>
 * </svg>
 *
 * ---------------------------------
 *
 * CONFIGURATION
 * ---------------------------------
 * {
 * 	"#Button_20_20Main": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 158,
 * 		"height": 40
 * 	},
 * 	"#Rectangle_2051": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 158,
 * 		"height": 40
 * 	},
 * 	"#JOIN_20THE_20MAIN_20TAB": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMaxYMid meet",
 * 		"width": 157.31304931640625,
 * 		"height": 40
 * 	},
 * 	"#Vector": {
 * 		"type": "SELECTOR",
 * 		"constraint": "none",
 * 		"width": 16,
 * 		"height": 16
 * 	},
 * 	"transforms": {
 * 		"DownloadIcon": [
 * 			{
 * 				"name": "DownloadIcon",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						28
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						11
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "DownloadIcon",
 * 				"isInstanceParent": true,
 * 				"isInstanceChild": false,
 * 				"width": 16,
 * 				"height": 16
 * 			}
 * 		],
 * 		"Vector": [
 * 			{
 * 				"name": "Vector",
 * 				"relativeTransforms": [
 * 					[
 * 						1,
 * 						0,
 * 						0
 * 					],
 * 					[
 * 						0,
 * 						1,
 * 						0
 * 					]
 * 				],
 * 				"rotation": 0,
 * 				"instanceParentName": "DownloadIcon",
 * 				"isInstanceParent": false,
 * 				"isInstanceChild": true,
 * 				"width": 16,
 * 				"height": 16
 * 			}
 * 		]
 * 	},
 * 	"tProps": {
 * 		"type": "PROPS",
 * 		"NewProductButton?": "tButtonProps",
 * 		"onAnimationComplete?": "() => void",
 * 		"ImportButton?": "tButtonProps"
 * 	},
 * 	"#NewProductButton": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.NewProductButton?.onPress",
 * 			"animation": "touchableOpacity"
 * 		},
 * 		"constraint": "none",
 * 		"width": 158,
 * 		"height": 40
 * 	},
 * 	"#DownloadIcon": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMinYMid meet",
 * 		"width": 16,
 * 		"height": 16
 * 	},
 * 	"#Import": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMaxYMid meet",
 * 		"width": 60,
 * 		"height": 26
 * 	},
 * 	"#Product": {
 * 		"type": "SELECTOR",
 * 		"constraint": "xMaxYMid meet",
 * 		"width": 73,
 * 		"height": 25
 * 	},
 * 	"#ImportButton": {
 * 		"type": "SELECTOR",
 * 		"touchableOpacity": {
 * 			"onPress": "props?.ImportButton?.onPress",
 * 			"animation": "touchableOpacity"
 * 		},
 * 		"constraint": "none",
 * 		"width": 158,
 * 		"height": 40
 * 	}
 * }
 * ---------------------------------
 *
 * DESCRIPTION
 * ---------------------------------
 * No description provided!
 * ---------------------------------
 */

/** Component Properties Interface */
export type tProps = {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  NewProductButton?: tButtonProps;
  onAnimationComplete?: () => void;
  ImportButton?: tButtonProps;
};
/***/

/***/

export type tStyle = StyleProp<ViewStyle>;
export type tTextStyle = StyleProp<TextStyle>;
/** Button Prop Types */

type tButtonProps = {
  onPress: () => void;
} & GProps;
/***/

/** Convenience for prop insertion from ast (no-color-literals/no-inline-styles) */

/* eslint-disable react-native/no-color-literals */

/* eslint-disable react-native/no-inline-styles */

/** Local Styles */

const kLocalStyles = StyleSheet.create({
  kOverlay: {
    left: 0,
    position: "absolute",
    top: 0,
  },
});
/***/

/***/

/**
 * Auto-Generated Imp.Blue Component based on your design!
 * @param {tProps} props Developer interface to the component!
 * @returns {JSX.Element} JSX
 *
 * Description --
 * No description provided!
 */

export const ImportButton = (props: {
  style?: tStyle;
  svgStyle?: tStyle;
  isInsideScrollView?: boolean;
  svgRef?: () => void;
  NewProductButton?: tButtonProps;
  onAnimationComplete?: () => void;
  ImportButton?: tButtonProps;
}): JSX.Element => {
  const {
    style = {
      width: 158,
      height: 40,
    },
    svgStyle = {
      width: "100%",
      height: "100%",
    },
    svgRef,
  } = props;

  function checkFont(myStrFamily: string) {
    let aReturnFamily;

    if (FontList) {
      FontList.get((fontFamilies: Array<string>) => {
        if (fontFamilies.includes(myStrFamily)) {
          aReturnFamily = myStrFamily;
        } else {
          console.warn(`"${myStrFamily}" is not a valid font. Using "${fontFamilies[0]}" instead. `);
          aReturnFamily = fontFamilies[0];
        }
      });
    } else {
      aReturnFamily = myStrFamily;
    }

    return aReturnFamily;
  }

  /** Component Internal State */

  const [buttonState, setButtonState] = React.useState<{
    NewProductButtonButtonOpacity: number;
    ImportButtonButtonOpacity: number;
  }>({
    NewProductButtonButtonOpacity: 1,
    ImportButtonButtonOpacity: 1,
  });
  /** Component Internal Functions */

  /** Custom React-Hooks */

  /**
   * Custom hook to emulate onLayout events
   * (For use in web env only!)
   */

  /** End Custom React-Hooks */

  /** Button Wrapper */
  // #region NewProductButton Button Handlers

  /***/
  // #endregion
  // #region ImportButton Button Handlers

  const { ImportButton = {} } = props;
  const { onPress: ImportButtonOnPress, ...ImportButtonProps } = ImportButton as tButtonProps;

  const ImportButtonButtonPressInFunction = () => 0;

  const ImportButtonButtonPressOutFunction = ImportButtonOnPress;

  const ImportButtonButtonActive = (callback?: () => void) => {
    setButtonState({ ...buttonState, ImportButtonButtonOpacity: 0.2 });

    if (callback) {
      callback();
    }
  };

  const ImportButtonButtonInactive = (callback?: () => void) => {
    setButtonState({ ...buttonState, ImportButtonButtonOpacity: 1 });

    if (callback) {
      callback();
    }
  };

  const ImportButtonOnPressIn = () => {
    ImportButtonButtonActive(ImportButtonButtonPressInFunction);
  };

  const ImportButtonOnPressOut = () => {
    ImportButtonButtonInactive(ImportButtonButtonPressOutFunction);
  };
  /***/
  // #endregion

  /** End Button Wrapper */

  /** Component Render (Javascript-React Markup) */

  if (Platform.OS === "web") {
    return (
      <View style={style}>
        <Svg fill="none" id="svg_root" ref={svgRef} style={svgStyle}>
          <G
            id="ImportButton"
            opacity={buttonState.ImportButtonButtonOpacity}
            onMouseDown={ImportButtonOnPressIn}
            onMouseUp={ImportButtonOnPressOut}
            cursor="pointer"
            {...ImportButtonProps}
          >
            <Svg preserveAspectRatio="none" viewBox="0 0 158 40">
              <Path
                id="Rectangle_2051"
                fill="#2C4B46"
                d="M2 0 H156 a2,2 0 0 1 2,2 V38 a2,2 0 0 1 -2,2 H2 a2,2 0 0 1 -2,-2 V2 a2,2 0 0 1 2,-2z"
                strokeWidth="1"
                vectorEffect="non-scaling-stroke"
              />
            </Svg>
            <Svg preserveAspectRatio="xMaxYMid meet" viewBox="0 0 158 40">
              <Text
                id="Import"
                fill="white"
                fontSize={14}
                fontWeight={600}
                letterSpacing="0.06em"
                fontFamily={checkFont("Raleway")}
              >
                <TSpan x={88} y={0.441998} id="Import_elem0" />
                <TSpan x={59.3834} y={25.442} id="Import_elem1">
                  {"IMPORT"}
                </TSpan>
              </Text>
            </Svg>
            <Svg preserveAspectRatio="xMinYMid meet" viewBox="0 0 158 40">
              <G id="DownloadIcon">
                <Svg preserveAspectRatio="none" viewBox="0 0 158 40">
                  <Path
                    id="Vector"
                    d="M42 22V25H30V22H28V25C28 26.1 28.9 27 30 27H42C43.1 27 44 26.1 44 25V22H42ZM41 18L39.59 16.59L37 19.17V11H35V19.17L32.41 16.59L31 18L36 23L41 18Z"
                    fill="white"
                    strokeWidth="1"
                    vectorEffect="non-scaling-stroke"
                  />
                </Svg>
              </G>
            </Svg>
          </G>
        </Svg>
      </View>
    );
  }

  return (
    <View style={style}>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="none"
        viewBox="0 0 158 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Path
          id="Rectangle_2051"
          fill="#2C4B46"
          d="M2 0 H156 a2,2 0 0 1 2,2 V38 a2,2 0 0 1 -2,2 H2 a2,2 0 0 1 -2,-2 V2 a2,2 0 0 1 2,-2z"
          strokeWidth="1"
          vectorEffect="non-scaling-stroke"
        />
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMaxYMid meet"
        viewBox="0 0 158 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <Text
          id="Import"
          fill="white"
          fontSize={14}
          fontWeight={600}
          letterSpacing="0.06em"
          fontFamily={checkFont("Raleway")}
        >
          <TSpan x={88} y={0.441998} id="Import_elem0" />
          <TSpan x={59.3834} y={25.442} id="Import_elem1">
            {"IMPORT"}
          </TSpan>
        </Text>
      </Svg>
      <Svg
        id="native_constraint_wrapper"
        preserveAspectRatio="xMinYMid meet"
        viewBox="0 0 158 40"
        style={[svgStyle, kLocalStyles.kOverlay]}
      >
        <G id="DownloadIcon">
          <Path
            id="Vector"
            d="M42 22V25H30V22H28V25C28 26.1 28.9 27 30 27H42C43.1 27 44 26.1 44 25V22H42ZM41 18L39.59 16.59L37 19.17V11H35V19.17L32.41 16.59L31 18L36 23L41 18Z"
            fill="white"
            strokeWidth="1"
            vectorEffect="non-scaling-stroke"
          />
        </G>
      </Svg>
    </View>
  );
};
/***/

export default React.memo(ImportButton);
